import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import List from '../../components/Entity/Agents/List/List';

const AgentsPage = () => {
  return <Layout fullwidth={0}>
   
      <List></List>
  
  </Layout>;
}

export default AgentsPage;
